import { render } from "./InviteView.vue?vue&type=template&id=5d2cdda1&scoped=true"
import script from "./InviteView.vue?vue&type=script&lang=js"
export * from "./InviteView.vue?vue&type=script&lang=js"

import "./InviteView.vue?vue&type=style&index=0&id=5d2cdda1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d2cdda1"]])

export default __exports__